import React from 'react';
import * as styles from './SharingDropdownRow.module.scss';

type SharingDropdownRowProps = { right: React.ReactNode } & (
  | { info: React.ReactNode }
  | {
      icon: React.ReactNode;
      title: React.ReactNode;
      description: React.ReactNode;
    }
);

const SharingDropdownRow = ({ right, ...props }: SharingDropdownRowProps) => (
  <div className={styles.row}>
    {'info' in props ? (
      props.info
    ) : (
      <div className={styles.info}>
        <div>{props.icon}</div>
        <div className={styles.main}>
          {props.title}
          <div className={styles.secondary}>{props.description}</div>
        </div>
      </div>
    )}
    <div className={styles.role}>{right}</div>
  </div>
);

export default SharingDropdownRow;
